"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CimdocShapeFormat = void 0;
var CimdocShapeFormat;
(function (CimdocShapeFormat) {
    CimdocShapeFormat["SvgPath"] = "svgpath";
    CimdocShapeFormat["PathOperations"] = "pathOperation";
})(CimdocShapeFormat = exports.CimdocShapeFormat || (exports.CimdocShapeFormat = {}));
//# sourceMappingURL=types.js.map